module.exports = __webpack_public_path__ + "img/back.9d96deb3.jpeg";